<mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>

<ng-container *ngIf="filteredInvites.length; else noItems">
    <mat-list>
        <mat-list-item *ngFor="let invite of filteredInvites | slice:0:shown" [class.disabled]="!invite.isCompleted && invite.isExpired"
            [class.quick-add-invite]="invite.isQuickAdd" (click)="invite.isCompleted ? loadInviteDetails(invite) : null"
            class="auto-height">
            <div class="list-item stack-mobile">
                <div class="details">
                    <div matLine class="primary-text">
                        <b>{{ invite.surname }}, {{ invite.name }}</b>
                        <span class="primary-text-aside" [ngClass]="invite.statusClasses">
                            ({{ invite.status }})
                        </span>
                    </div>
                    <div matLine class="secondary-text">
                        <span>{{ invite.email }}</span>
                    </div>
                    <div class="quick-add-label" *ngIf="invite.isQuickAdd" matTooltip="Invite sent when adding the patient via express add">
                        <mat-icon class="quick-add-icon">bolt</mat-icon>
                        <span>Express Added</span>
                    </div>
                </div>

                <div class="action-icons">
                    <!-- Only show if invite is not completed and token is present -->
                    <button mat-icon-button *ngIf="!invite.isCompleted && invite.inviteToken"
                        matTooltip="Open invite in a new tab for completion" (click)="completeInvite(invite, $event)">
                        <mat-icon>open_in_browser</mat-icon>
                    </button>

                    <!-- Only show if invite is completed -->
                    <button mat-icon-button *ngIf="invite.isCompleted"
                        matTooltip="Update patient file details using the invite details and complete the invite process">
                        <mat-icon>content_copy</mat-icon>
                    </button>

                    <!-- Revoke, resend, etc. remain unchanged -->
                    <button mat-icon-button *ngIf="!invite.isCompleted" (click)="revokeInvite(invite, $event)"
                        [disabled]="!invite.inviteId" matTooltip="Revoke this invite">
                        <mat-icon>delete</mat-icon>
                    </button>

                    <button mat-icon-button *ngIf="!invite.isCompleted" (click)="resendInvite(invite, $event)"
                        [disabled]="!invite.inviteId || !getResendCooldown(invite).canResend"
                        [matTooltip]="invite.inviteId ? getResendCooldownTooltip(invite) : 'Loading…'">
                        <mat-icon>send</mat-icon>
                    </button>

                    <button mat-icon-button matTooltip="View the patient file"
                        (click)="navigateToPatientFile($event, invite.id)">
                        <mat-icon>visibility</mat-icon>
                    </button>
                </div>
            </div>
        </mat-list-item>
        <div *ngIf="shown < filteredInvites.length" (appRenderMore)="shown = shown + renderBatch"></div>
    </mat-list>
</ng-container>

<div class="mobile-spacer"></div>

<ng-template #noItems>
    <p class="no-records-message" *ngIf="!loading">No patient invites found.</p>
</ng-template>


<!-- <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>

<ng-container *ngIf="filteredInvites.length; else noItems">
    <mat-list>
        <mat-list-item *ngFor="let invite of filteredInvites"
            [class.disabled]="!isInviteCompleted(invite) && isInviteExpired(invite)"
            (click)="isInviteCompleted(invite) ? loadInviteDetails(invite) : null" class="auto-height">
            <div class="list-item  stack-mobile">
                <div class="details">

                    <div matLine class="primary-text">
                        <b>{{ invite.surname }}, {{ invite.name }}</b>
                        <span class="primary-text-aside" [ngClass]="getStatusClasses(invite)">
                            ({{ getInviteStatus(invite) }})
                        </span>
                    </div>
                    <div matLine class="secondary-text">
                        <span>{{ invite.email }}</span>

                    </div>
                </div>
                <div class="action-icons">
                    <button mat-icon-button *ngIf="!isInviteCompleted(invite) && invite.inviteToken"
                        matTooltip="Open invite in a new tab for completion" (click)="completeInvite(invite, $event)">
                        <mat-icon>open_in_browser</mat-icon>
                    </button>
                    <button mat-icon-button *ngIf="isInviteCompleted(invite)"
                        matTooltip="Update patient file details using the invite details and complete the invite process">
                        <mat-icon>content_copy</mat-icon>
                    </button>
                    <button mat-icon-button (click)="revokeInvite(invite.inviteId, $event)"
                        matTooltip="Revoke this invite">
                        <mat-icon>delete</mat-icon>
                    </button>
                    <button mat-icon-button (click)="resendInvite(invite, $event)" matTooltip="Resend this invite">
                        <mat-icon>send</mat-icon>
                    </button>
                    <button mat-icon-button matTooltip="View the patient file"
                        (click)="navigateToPatientFile($event, invite.id)">
                        <mat-icon>visibility</mat-icon>
                    </button>
                </div>
            </div>
        </mat-list-item>
    </mat-list>
</ng-container>
<div class="mobile-spacer"></div>

<ng-template #noItems>
    <p class="no-records-message" *ngIf="!loading">No patient invites found.</p>
</ng-template> -->